import { getGlobalHeadersAsObject } from "../global-headers";

export type EmailAutocomplete = {
	person_id: number;
	person_name: string;
	email: string;
};

export type EmailStats = {
	total: number;
	my_total: number;
	by_method: Record<string, number>;
	connected: boolean;
};

export const getEmailAutocomplete = (query: string): Promise<EmailAutocomplete[]> => {
	// encodeURIComponent, or a character with a meaning in a query string ends
	// the parameter early: an ampersand truncates the search at it, and a plus
	// arrives as a space. The company picker searched for "H" every time
	// somebody typed "H&M" until this was fixed there.
	return fetch(`/api/v2/emails/?query=${encodeURIComponent(query)}`, {
		method: "GET",
		headers: getGlobalHeadersAsObject(),
	}).then((res) => res.json());
};

export const getEmailStats = (): Promise<EmailStats> => {
	return fetch(`/api/v2/email-stats/summary/`, {
		method: "GET",
		headers: getGlobalHeadersAsObject(),
	}).then((res) => res.json());
};

export const clearMyEmails = (): Promise<{ deleted: number }> => {
	return fetch(`/api/v2/email-stats/clear_my_emails/`, {
		method: "DELETE",
		headers: getGlobalHeadersAsObject(),
	}).then((res) => res.json());
};
